import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

export const getScheduleResolutions = api(async function scheduleResolutions({ id }) {
    if (!id) return null
    return query(
        gql`
            query GetScheduleResolutions($id: ID!) {
                scheduleResolutions(id: $id)
            }
        `,
        { id },
        { returns: "scheduleResolutions" }
    )
})
